"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useInteractiveToast = void 0;
var _react = require("react");
const toastNotReadyMessage = "Toast not ready yet. Please wait a tick for subscription to the" + " SdsToastStateService. Toasts should be queued due to a user action," + " not directly within a React render cycle.";
const defaultRequestedResult = {
  queue: () => {
    throw new Error(toastNotReadyMessage);
  },
  remove: () => {
    throw new Error(toastNotReadyMessage);
  }
};
const useInteractiveToast = _ref => {
  let {
    manager,
    autoCloseDelay
  } = _ref;
  // We should have these immediately upon requesting a toast.
  const [requestedArgs, setRequestedArgs] = (0, _react.useState)(defaultRequestedResult);

  // Once a Toaster is actually registered, these come in as well for use.
  // They might be ready immediately, or they might be ready later.
  const [elementReadyArgs, setElementReadyArgs] = (0, _react.useState)(() => ({
    element: null
  }));
  (0, _react.useEffect)(() => {
    const {
      cancelRequest,
      ...requestToastResult
    } = manager.requestInteractiveToast({
      onElementReady: setElementReadyArgs,
      autoCloseDelay
    });

    // We get these back first and the user can use them to queue the toast.
    setRequestedArgs(requestToastResult);
    return cancelRequest;
  }, [manager, autoCloseDelay]);
  return {
    getToastPortalProps: () => {
      return {
        element: elementReadyArgs?.element ?? null
      };
    },
    getToastProps: function () {
      let overrides = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return {
        onMouseEnter: e => {
          manager.pauseAutoRemove();
          overrides.onMouseEnter?.(e);
        },
        onMouseLeave: e => {
          manager.restartAutoRemove();
          overrides.onMouseLeave?.(e);
        }
      };
    },
    toastActions: requestedArgs
  };
};
exports.useInteractiveToast = useInteractiveToast;
//# sourceMappingURL=useInteractiveToast.js.map